import Image from "next/image";
import { MediaProp } from "types";
import { getStrapiMedia } from "utils";
import IconOnline2 from "../../assets/images/svg/icon-online2.svg";

interface TextImageProp {
  data: {
    OS2?: string;
    Title?: string;
    Content?: string;
    Image?: MediaProp;
  };
}

const TextImage: React.FC<TextImageProp> = ({ data }) => {
  const { OS2, Title, Content, Image: imageObj } = data;

  return (
    <div className="text-image">
      <div className="container container--small">
        <div className="text-image__inner">
          <div className="text">
            {OS2 && <IconOnline2 />}
            {Title && <h2 className="text-image__title h3">{Title}</h2>}
            <p>{Content}</p>
          </div>
          <div className="image">
            {imageObj && imageObj.data && (
              <Image
                alt={imageObj.data.attributes.alternativeText || ""}
                src={getStrapiMedia(imageObj)}
                fill
                sizes="(max-width: 767px) calc(100vw - 48px), 434px"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextImage;
